export default {"src":"/_next/static/media/mailroom-logo-white.5f2c711b.svg","height":169,"width":652,"blurWidth":0,"blurHeight":0};